import React, { useState, useEffect } from 'react'
import SidebarProposal from './../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from './../../utils/loading'
import PanalLoadingTemplate from './../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from './../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr } from './../../utils/sessionHelpers'
import SearchExpertPaymentWidget from '../../widgets/searchExpertPayment/SearchExpertPaymentWidget'
import { getExpertPayment } from '../../redux/actions/searchExpertPayment'

export default function SearchExpertPayment({ step }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getExpertPayment(1, 5)
      if (response) {
        setSchema(response.model)
        // setSchema(mockSchema.model)
      } else {
        setError({})
      }
      console.log('response ', response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isReviewPayment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReviewPayment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isReviewPayment>
        <SearchExpertPaymentWidget schema={schema} projectCode={projectCode} />
        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ข้อมูลจ่ายผู้ทรงคุณวุฒิ',

    searchForm: {
      header: 'ค้นหาข้อมูลจ่ายผู้ทรงคุณวุฒิ',
      buttonSearch: 'ค้นหา',
      buttonCancel: 'ยกเลิก',
      firstName: {
        name: 'firstName',
        label: 'ชื่อ',
        value: '',
        validators: [],
      },
      lastName: {
        name: 'lastName',
        label: 'นามสกุล',
        value: '',
        validators: [],
      },

      ProjectId: {
        name: 'ProjectId',
        label: 'รหัสโครงการ',
        value: '',
        validators: [],
      },
      idCard: {
        name: 'idCard',
        label: 'เลขที่ประจำตัวประชาชน 13 หลัก',
        value: '',
        validators: [
          {
            type: 'MINLENGTH',
            value: 13,
            errorMessage: 'กรุณากรอกเลขที่ประจำตัวประชาชน 13 หลัก',
          },
          {
            type: 'MAXLENGTH',
            value: 13,
            errorMessage: 'กรุณากรอกเลขที่ประจำตัวประชาชน 13 หลัก',
          },
        ],
      },
    },
    result: {
      totalSize: 10,
      values: [
        {
          fullName: 'สมหนึ่ง สกุลหนึ่ง',
          ProjectId: 'p-660001',
          ProjectName: 'โครงการ1',
          BankId: '123-456-789',
          BankName: 'กรุงศรี',
          disbursementAmount: 100000,
          Status: 'ตัวอย่างสถานะ',
        },
        {
          fullName: 'สมสอง สกุลสอง',
          ProjectId: 'p-660002',
          ProjectName: 'โครงการ2',
          BankId: '123-456-789',
          BankName: 'กรุงไทย',
          disbursementAmount: 200000,
          Status: 'ตัวอย่างสถานะ',
        },
        {
          fullName: 'สมสาม สกุลสาม',
          ProjectId: 'p-660003',
          ProjectName: 'โครงการ3',
          BankId: '123-456-789',
          BankName: 'กรุงเทพ',
          disbursementAmount: 300000,
          Status: 'ตัวอย่างสถานะ',
        },
      ],
    },
  },
}
